var exports = {
  "uW": "VoiceActivitySection.module__section___VFk0en",
  "eV": "VoiceActivitySection.module__moreCallsText___VFk0en",
  "ti": "VoiceActivitySection.module__allCallsGrid___VFk0en",
  "ux": "VoiceActivitySection.module__gridItem___VFk0en",
};

module.exports = exports;
